import { ClickAwayListener, Tooltip, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Component } from "react";

class InfoButtonWithTooltip extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.description !== nextProps.description || this.state.open !== nextState.open;
    }

    handleDelete() {}

    handleTooltipClose() {
        this.setState({ open: false });
    }

    handleTooltipOpen() {
        this.setState({ open: true });
    }

    render() {
        return (
            <ClickAwayListener onClickAway={this.handleTooltipClose.bind(this)}>
                <Tooltip
                    PopperProps={{
                        disablePortal: true,
                    }}
                    onClose={this.handleTooltipClose.bind(this)}
                    open={this.state.open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={this.props.description}
                >
                    <IconButton onClick={this.handleTooltipOpen.bind(this)}>
                        <InfoIcon />
                    </IconButton>
                </Tooltip>
            </ClickAwayListener>
        );
    }
}

export default InfoButtonWithTooltip;
